import React, { useEffect, useState } from "react";
import {
  Modal,
  TextInput,
  Select,
  PasswordInput,
  Button,
  SimpleGrid,
  LoadingOverlay,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { useSetState } from "@mantine/hooks";
import { apiWithInterceptor } from "../../../../api";
const EditUserModal = ({ opened, currentUser, setOpenEditUserModal }) => {
  const [visible, setVisible] = useState(false);
  const [userData, setUserData] = useSetState({
    password: undefined,
    userName: "",
    email: "",
    privilege: "",
  });

  useEffect(() => {
    if (currentUser.length > 0) {
      setVisible(true);
      apiWithInterceptor.get(`/user/${currentUser}`).then((res) => {
        setUserData({
          password: undefined,
          userName: res.data.username,
          email: res.data.email,
          privilege: res.data.privileges,
        });
        setVisible(false);
      });
    }
  }, [currentUser]);

  const userPrivileges = [
    { value: "ADMIN", label: "Admin" },
    { value: "USER", label: "User" },
  ];

  return (
    <Modal
      opened={opened}
      onClose={() => setOpenEditUserModal(false)}
      title="Edit User"
    >
      <LoadingOverlay visible={visible} overlayBlur={2} />
      <SimpleGrid verticalSpacing="lg">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            apiWithInterceptor
              .patch(`/user/${currentUser}`, {
                username: userData.userName,
                email: userData.email,
                password: userData.password,
                privileges: userData.privilege,
              })
              .then(() => {
                showNotification({
                  title: `User successfuly updated`,
                  message: "The user information has been updated",
                  color: "green",
                });
                setOpenEditUserModal(false);
              })
              .catch(() => {
                showNotification({
                  title: `Something went wrong`,
                  message:
                    "Either you entered some invalid data or an Internet connection error",
                  color: "red",
                });
              });
          }}
        >
          <TextInput
            label="User Name"
            placeholder="Enter new user name"
            data-autofocus
            value={userData.userName}
            onChange={(e) => {
              setUserData({ userName: e.target.value });
            }}
          />
          <TextInput
            label="User Email"
            placeholder="Enter the new user Email"
            data-autofocus
            value={userData.email}
            onChange={(e) => {
              setUserData({ email: e.target.value });
            }}
          />
          <PasswordInput
            label="New user password"
            placeholder="New user password"
            value={userData.password}
            onChange={(e) => {
              setUserData({ password: e.target.value });
            }}
          />
          <Select
            data={userPrivileges}
            placeholder="Set user privileges"
            label="Set user privileges"
            value={userData.privilege}
            onChange={(e) => {
              setUserData({ privilege: e });
            }}
          />

          <Button fullWidth style={{ marginTop: "10px" }} type="submit">
            Update User Info
          </Button>
          <Button
            color="red"
            fullWidth
            style={{ marginTop: "10px" }}
            onClick={() => {
              setOpenEditUserModal(false);
            }}
          >
            Cancel
          </Button>
        </form>
      </SimpleGrid>
    </Modal>
  );
};

export default EditUserModal;
